import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-sticky-mobile-footer',
    templateUrl: './sticky-mobile-footer.component.html',
    styleUrls: ['./sticky-mobile-footer.component.css'],
    standalone: false
})
export class StickyMobileFooterComponent {
  @Output() contactUs = new EventEmitter<void>();
  @Output() writeReview = new EventEmitter<void>();

  constructor() { }


  contact() {
    this.contactUs.emit();
  }

  review() {
    this.writeReview.emit();
  }

}
